var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3334 5.66667H12C12.7334 5.66667 13.3334 6.26667 13.3334 7V13.6667C13.3334 14.4 12.7334 15 12 15H4.00002C3.26669 15 2.66669 14.4 2.66669 13.6667V7C2.66669 6.26667 3.26669 5.66667 4.00002 5.66667H4.66669V4.33333C4.66669 2.49333 6.16002 1 8.00002 1C9.84002 1 11.3334 2.49333 11.3334 4.33333V5.66667ZM8.00002 2.33333C6.89335 2.33333 6.00002 3.22667 6.00002 4.33333V5.66667H10V4.33333C10 3.22667 9.10669 2.33333 8.00002 2.33333ZM4.00002 13.6667V7H12V13.6667H4.00002ZM9.33335 10.3333C9.33335 11.0667 8.73335 11.6667 8.00002 11.6667C7.26669 11.6667 6.66669 11.0667 6.66669 10.3333C6.66669 9.6 7.26669 9 8.00002 9C8.73335 9 9.33335 9.6 9.33335 10.3333Z",
    fill: "#5C6370"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock.1f976876.svg";
export { ForwardRef as ReactComponent };